<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} đánh giá</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} đánh giá</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="3">
              <el-form-item label="Người đánh giá" prop="nguoi_danh_gia">
                <el-input v-model="mData.dataForm.nguoi_danh_gia" disabled clearable @input="forceUpdateUI"></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Đối tượng đánh giá" prop="doi_tuong_danh_gia">
                <el-input v-model="mData.dataForm.doi_tuong_danh_gia" disabled clearable
                  @input="forceUpdateUI"></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Số sao" prop="gia_tri">
                <el-input v-model="mData.dataForm.gia_tri" disabled clearable @input="forceUpdateUI"></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Trạng thái hiển thị" prop="hien_thi">
                <el-select v-model="mData.dataForm.hien_thi" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listHienThi" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Trạng thái khoá" prop="lock">
                <el-select v-model="mData.dataForm.lock" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listKhoa" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="noi_dung">
                <el-input type="textarea" :rows="3" v-model="mData.dataForm.noi_dung" disabled clearable
                  @input="forceUpdateUI"></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12" v-if="this.mData.dataForm.thong_tin_them.media.length > 0">
              <el-form-item class="mb-0" label="File đính kèm">
                <b-row>
                  <b-col md="2" class="text-center mt-2" v-for="item in mData.fileUploadOption.FileDinhKem.fileList"
                    :key="item.name">
                    <el-image style="width: 100px; height: 100px" :src="item.url"
                      :preview-src-list="mData.dataDefault.listFileDinhKem" v-if="!fn_checkVideo(item)">
                      <div slot="error" class="el-image__error">
                        <!-- <i class="el-icon-picture-outline"></i> -->
                        <span class="small" style="line-height: 1rem">{{
                          item.name
                        }}</span>
                      </div>
                    </el-image>
                    <div style="position: relative; cursor: pointer;" v-if="fn_checkVideo(item)"
                      @click="fn_playVideo(item)">
                      <video width="100px" height="100px">
                        <source :src="item.url" :type="fn_changeType(item.extension)" />
                      </video>
                      <div
                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 24px; height: 24px; border-radius: 36px; background-color: rgba(80, 67, 67, 0.79); display: flex; align-items: center; border: 1px solid #ffffff;">
                        <i class="fa fa-play"
                          style="font-size: 14px; color: #ffffff; font-weight: 100; margin-left: 7px;"
                          aria-hidden="true"></i>
                      </div>
                    </div>
                    <div>
                      <el-button @click="fn_download(item)" type="info" size="small" plain>Tải về</el-button>
                    </div>
                  </b-col>
                </b-row>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="this.mData.tableRules.data.length > 0">
            <b-col md="12" class="mb-2">Danh sách phản hồi đánh giá</b-col>
            <b-col md="12">
              <el-table :data="mData.tableRules.data" border max-height="440" style="width: 100%; display: grid"
                :row-class-name="fn_tableRowClassName">
                <el-table-column prop="ten_nguoi_danh_gia" label="Người phản hồi" min-width="170px">
                </el-table-column>
                <el-table-column prop="noi_dung" label="Nội dung" min-width="150px">
                </el-table-column>
                <el-table-column prop="thoi_diem_danh_gia" label="Thời điểm phản hồi" :formatter="fn_formatterDatetime"
                  width="160px">
                  <template slot-scope="scope">
                    <div class="text-center">{{ fn_formatterDatetimeList(scope.row.thoi_diem_danh_gia) }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="hien_thi" label="Trạng thái hiển thị" width="130px">
                  <template slot-scope="scope">
                    <div class="text-center">{{ scope.row.hien_thi ? "Hiển thị" : "Không hiển thị" }}</div>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  label="File đính kèm"
                  min-width="150px"
                >

                </el-table-column> -->
              </el-table>
              <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                <div class="col-md-4">
                  <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}:
                    {{ mData.tableRules.recordSelected.length }}</div>
                </div>
                <div class="col-md-8 text-right">
                  <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
                    @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick"
                    :page-sizes="mData.tableRules.lengthMenu" :page-size="mData.tableRules.limit"
                    :current-page="mData.tableRules.page" background layout="total, sizes, prev, pager, next, jumper"
                    :total="mData.tableRules.total" :pager-count="5"></el-pagination>
                </div>
              </b-row>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">{{
              aLang.c_update
            }}</el-button>
            <el-button @click="fn_go()" type="info" plain>
              {{ aLang.c_back }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div
      style="position: fixed; width: 100%; height: 100%; background: rgba(80, 67, 67, 0.79); top: 0; left: 0; z-index: 99999;"
      v-if="mData.dataDefault.dialogVideo.show">
      <div
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); max-width: 80%, max-height: 80%;">
        <video autoplay controls style="max-height: 100vh;">
          <source :src="mData.dataDefault.dialogVideo.src" :type="mData.dataDefault.dialogVideo.type">
        </video>
      </div>
      <div style="position: absolute; right: 20px; top: 10px; cursor: pointer;" @click="fn_closeDialogVideo()">
        <i class="fa fa-times" style="font-size: 36px; color: #ffffff;" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ApiService from '@/service/ApiService';
import DanhGiaModel from "./DanhGiaModel";
import DanhGiaApi from '@/moduleApi/DanhGiaApi';
import config from "../../../config.json";
import ProfileApi from '@/moduleApi/ProfileApi';
import KhachDuLichApi from '@/moduleApi/KhachDuLichApi';
import DichVuApi from '@/moduleApi/DichVuApi';
import TourDuLichApi from '@/moduleApi/TourDuLichApi';

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DanhGia",
        dataDefault: {
          roles: DataService.rolesInForm,
          listHienThi: DataService.visibleList,
          listKhoa: MethodService.copyObject(DanhGiaModel.listKhoa),
          listNguoiGuiDanhGia: [],
          listNguoiDanhGia: [],
          listNguoiDanhGiaKDL: [],
          listDoiTuongDanhGia: [],
          listFileDinhKem: [],
          listFileId: [],
          listPhanHoiDanhGia: [],
          listFilePhanHoiDanhGia: [],
          dataForDialog: {},
          allowChange: false,
          dialogVideo: {
            show: false,
            src: "",
            type: ""
          }
        },
        dataForm: MethodService.copyObject(DanhGiaModel.dataForm),
        tableRules: MethodService.copyObject(DanhGiaModel.tableRules),
        validForm: DanhGiaModel.validForm,
        fileUploadOption: MethodService.copyObject(
          DanhGiaModel.dataFormOther.fileUploadOption
        ),
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
      },
    };
  },
  methods: {
    fn_go() {
      this.$router.go(-1);
    },

    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "update") {
            await DanhGiaApi.update(data);
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_getDataById(id) {
      const resDanhGiaApi = await DanhGiaApi.findById(id);
      if (resDanhGiaApi.result) {
        this.mData.dataForm = resDanhGiaApi.result;
        const resNguoiDanhGiaApi = await ProfileApi.findById(resDanhGiaApi.result.nguoi_danh_gia_id);
        const resNguoiDanhGiaKhachDuLichApi = await KhachDuLichApi.findById(resDanhGiaApi.result.nguoi_danh_gia_id);
        const resDichVuApi = await DichVuApi.findById(resDanhGiaApi.result.doi_tuong_danh_gia_id);
        const resDichVuTourApi = await TourDuLichApi.findById(resDanhGiaApi.result.doi_tuong_danh_gia_id);

        if (resNguoiDanhGiaApi.result && resNguoiDanhGiaApi.result.ho_ten.ho_ten.trim()) {
          this.mData.dataForm.nguoi_danh_gia = resNguoiDanhGiaApi.result.ho_ten.ho_ten;
        } else if (resNguoiDanhGiaKhachDuLichApi.result && resNguoiDanhGiaKhachDuLichApi.result.ho_ten.ho_ten.trim()) {
          this.mData.dataForm.nguoi_danh_gia = resNguoiDanhGiaKhachDuLichApi.result.ho_ten.ho_ten;
        } else {
          this.mData.dataForm.nguoi_danh_gia = "Chưa có thông tin";
        }
        if (resDichVuApi.result) {
          if (resDichVuApi.result.loai == "yellow_page_place") {
            this.mData.dataForm.doi_tuong_danh_gia = resDichVuApi.result.diem_den.ten;
          } else if (
            resDichVuApi.result.loai == "hotel" ||
            resDichVuApi.result.loai == "tourist_villa" ||
            resDichVuApi.result.loai == "tourist_apartment" ||
            resDichVuApi.result.loai == "tourist_cruise" ||
            resDichVuApi.result.loai == "camping" ||
            resDichVuApi.result.loai == "motel" ||
            resDichVuApi.result.loai == "homestay"
          ) {
            this.mData.dataForm.doi_tuong_danh_gia = resDichVuApi.result.luu_tru.ten;
          } else if (resDichVuApi.result.loai == "restaurant") {
            this.mData.dataForm.doi_tuong_danh_gia = resDichVuApi.result.am_thuc.ten;
          } else if (resDichVuApi.result.loai == "entertainment") {
            this.mData.dataForm.doi_tuong_danh_gia = resDichVuApi.result.giai_tri.ten;
          } else if (resDichVuApi.result.loai == "ticket") {
            this.mData.dataForm.doi_tuong_danh_gia = resDichVuApi.result.ve_dien_tu.ten;
          }
        } else if (resDichVuTourApi.result) {
          this.mData.dataForm.doi_tuong_danh_gia = resDichVuTourApi.result.ten_tour;
        } else {
          this.mData.dataForm.doi_tuong_danh_gia = "Chưa có thông tin";
        }

        if (
          resDanhGiaApi.result.thong_tin_them &&
          resDanhGiaApi.result.thong_tin_them.media &&
          resDanhGiaApi.result.thong_tin_them.media.length > 0
        ) {
          let imageExtension = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".tiff", ".webp", ".svg"];
          await ApiService.get(config.hostApiDuLich + 'files?$limit=' + resDanhGiaApi.result.thong_tin_them.media.length + '&id:in:'
            + resDanhGiaApi.result.thong_tin_them.media.join(","), {}).then(listFile => {
              let data = [];
              if (listFile && listFile.result) {
                data = listFile.result;
                data.map((item) => {
                  item.url = ExtensionService.urlImg + item.id;
                });

                let imageUrls = listFile.result.filter(x => typeof (x.extension) == "string" && imageExtension.includes(x.extension.toLowerCase())).map((a) => a.url);
                this.mData.dataDefault.listFileDinhKem = imageUrls;
              }
              this.mData.fileUploadOption.FileDinhKem.fileList = data;
            });
        }
        let dataFilter = {
          filters: "danh_gia_id=" + id
        }
        const resListPhanHoiApi = await DanhGiaApi.list(dataFilter);
        let resData = await this.fn_changeData(resListPhanHoiApi.result);
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = resListPhanHoiApi.meta.total;
        this.mData.tableRules.page = resListPhanHoiApi.meta.offset / resListPhanHoiApi.meta.limit + 1;
        this.forceUpdateUI();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let nguoiDanhGiaIds = [];
      nguoiDanhGiaIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_danh_gia_id"
      );
      const reqNguoiDanhGiaApi = await ProfileApi.list({
        limit: nguoiDanhGiaIds.length,
        filters: "id:in:" + nguoiDanhGiaIds.join(",")
      })
      const reqNguoiDanhGiaKhachDuLichApi = await KhachDuLichApi.list({
        limit: nguoiDanhGiaIds.length,
        filters: "id:in:" + nguoiDanhGiaIds.join(",")
      });

      let resNguoiDanhGiaApi = await reqNguoiDanhGiaApi;
      let resNguoiDanhGiaKDLApi = await reqNguoiDanhGiaKhachDuLichApi;
      this.mData.dataDefault.listNguoiDanhGia = resNguoiDanhGiaApi.result;
      this.mData.dataDefault.listNguoiDanhGiaKDL = resNguoiDanhGiaKDLApi.result;

      resData.forEach(async (item) => {
        let nguoiDanhGia = this.mData.dataDefault.listNguoiDanhGia.find(
          element => {
            return element.id == item.nguoi_danh_gia_id;
          }
        );
        let nguoiDanhGiaKDL = this.mData.dataDefault.listNguoiDanhGiaKDL.find(
          element => {
            return element.id == item.nguoi_danh_gia_id;
          }
        );
        if (nguoiDanhGia && nguoiDanhGia.ho_ten.ho_ten.trim()) {
          item.ten_nguoi_danh_gia = nguoiDanhGia.ho_ten.ho_ten;
        } else if (nguoiDanhGiaKDL && nguoiDanhGiaKDL.ho_ten.ho_ten.trim()) {
          item.ten_nguoi_danh_gia = nguoiDanhGiaKDL.ho_ten.ho_ten;
        } else {
          item.ten_nguoi_danh_gia = "Chưa có thông tin";
        }
      });
      return resData;
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_formatterDatetimeList(cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_formatterLink(id) {
      return ExtensionService.urlFile + id;
    },
    fn_formatterLinkName(id) {
      if (this.mData.dataDefault.listFilePhanHoiDanhGia) {
        let resfind = this.mData.dataDefault.listFilePhanHoiDanhGia.find((element) => {
          return element.id == id;
        });
        if (resfind) {
          return decodeURI(resfind.name);
        }
      }
      return "File";
    },


    fn_download(file) {
      window.open(ExtensionService.urlFile + file.id);
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.loc.coordinates[0] = lat;
      this.mData.dataForm.loc.coordinates[1] = lng;
    },

    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },

    fn_checkVideo(item) {
      let extensions = [".mp4", ".webm", ".ogg"];
      if (item.extension && extensions.includes(item.extension)) {
        return true;
      }
      return false;
    },

    fn_changeType(extension) {
      if (extension) {
        return "video/" + extension.replace(".", "");
      }
      return "";
    },

    fn_playVideo(item) {
      this.mData.dataDefault.dialogVideo.src = item.url;
      this.mData.dataDefault.dialogVideo.type = this.fn_changeType(item.extension);
      this.mData.dataDefault.dialogVideo.show = true;
    },
    fn_closeDialogVideo() {
      this.mData.dataDefault.dialogVideo.src = "";
      this.mData.dataDefault.dialogVideo.type = "";
      this.mData.dataDefault.dialogVideo.show = false;
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_tableRowClassName({ row }) {
      if (row.trang_thai == "waiting") {
        return "success-row";
      }
      return "";
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getAmThucList();
    },
  },
  created: function () {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () { },
};
</script>
